import { Component, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { NotifyService } from 'src/app/services/notify.service';
import { WindowRefServiceService } from 'src/app/services/window-ref-service.service';


@Component({
  selector: 'app-metrominial-form',
  templateUrl: './metrominial-form.component.html',
  styleUrls: ['./metrominial-form.component.scss'],
  providers: [WindowRefServiceService]
})
export class MetrominialFormComponent implements OnInit {
  isindevidualShow: boolean = false;
  ismarriaedShow: boolean = false;
  husbandorwifesShow: boolean = false;
  stateShow: boolean = false;
  cityShow: boolean = false;
  cityotherShow: boolean = false;


  isReady: boolean = false;
  isState: boolean = false;

  getinForm: FormGroup;
  viewModal: boolean = false;
  favoriteSeason: string = '';
  seasons: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  navbarOpen = false;
  fileData: any = null;

  countryArr: any = [];
  stateArr: any = [];
  cityArr: any = [];

  constructor(private winRef: WindowRefServiceService, private elementRef: ElementRef, private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, private notify: NotifyService, public mainservice: MainService) {
    this.getinForm = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      gotra: new FormControl('', Validators.required),
      dob: new FormControl('', Validators.required),
      mobile: new FormControl('', [Validators.required, Validators.pattern('[- +()0-9]+')
        , Validators.minLength(10), Validators.maxLength(10)]),
      height: new FormControl('', Validators.required),
      weight: new FormControl('', Validators.required),
      color: new FormControl('', Validators.required),
      education: new FormControl('', Validators.required),
      business: new FormControl('', Validators.required),
      monthly_income: new FormControl('', Validators.required),
      house: new FormControl('', Validators.required),
      mangalik: new FormControl('', Validators.required),
      special_status: new FormControl('', Validators.required),
      brother_married: new FormControl('', Validators.required),
      brother_unmarried: new FormControl('', Validators.required),
      father: new FormControl('', Validators.required),
      mother: new FormControl('', Validators.required),
      sister_married: new FormControl('', Validators.required),
      sister_unmarried: new FormControl('', Validators.required),

      fname: new FormControl('', Validators.required),
      father_business: new FormControl('', Validators.required),
      father_monthly_income: new FormControl('', Validators.required),
      father_other: new FormControl(''),

      address: new FormControl('', Validators.required),
      country_id: new FormControl('', Validators.required),
      state_id: new FormControl(''),
      city_id: new FormControl(''),
      city_other: new FormControl(''),

      pincode: new FormControl('', [Validators.required, Validators.pattern('[- +()0-9]+'), Validators.minLength(4), Validators.maxLength(6)]),
      remark: new FormControl('', Validators.required),
      marriage_type: new FormControl('', Validators.required),
      payment_mode: new FormControl(''),
      payment_type: new FormControl(''),
      // idproof: new FormControl(''),
    });


  }
  get gf(): any {
    return this.getinForm['controls'];
  }


  openNav() {
    this.navbarOpen = !this.navbarOpen;
  }

  onFileChange(event: any, imageType: any) {
    if (event.target.files && event.target.files.length > 0) {
      if (["image/jpg", "image/jpeg", "image/png"].includes(event.target.files[0].type)) {
        let input = new FormData();
        if (imageType == "profile") {
          let fileSelected: File = event.target.files[0];
          input.append('profile', fileSelected);
          this.fileData = input;
          var reader = new FileReader();
          reader.readAsDataURL(fileSelected);
          reader.onload = (_event) => {
          }
        }

        if (imageType == "idproof") {
          let fileSelected: File = event.target.files[0];
          input.append('idproof', fileSelected);
          this.fileData = input;
          var reader = new FileReader();
          reader.readAsDataURL(fileSelected);
          reader.onload = (_event) => {
          }
        }
      }
    }
  }





  submit() {
    if (this.getinForm.valid) {
      this.isReady = true;
      let city_oth = this.gf.city_id.value == 'other' ? this.gf.city_other.value : this.gf.country_id.value == 'other' ? this.gf.city_other.value : '';
      if (this.fileData == null) {
        let input = new FormData();
        input.append("name", this.gf.name.value);
        input.append("gotra", this.gf.gotra.value);
        input.append("dob", this.gf.dob.value);
        input.append("mobile", this.gf.mobile.value);
        input.append("height", this.gf.height.value);
        input.append("weight", this.gf.weight.value);
        input.append("color", this.gf.color.value);
        input.append("education", this.gf.education.value);
        input.append("business", this.gf.business.value);
        input.append("monthly_income", this.gf.monthly_income.value);
        input.append("house", this.gf.house.value);
        input.append("mangalik", this.gf.mangalik.value);
        input.append("special_status", this.gf.special_status.value);
        input.append("brother_married", this.gf.brother_married.value);
        input.append("brother_unmarried", this.gf.brother_unmarried.value);
        input.append("father", this.gf.father.value);
        input.append("mother", this.gf.mother.value);
        input.append("sister_married", this.gf.sister_married.value);
        input.append("sister_unmarried", this.gf.sister_unmarried.value);
        input.append("fname", this.gf.fname.value);
        input.append("father_business", this.gf.father_business.value);
        input.append("father_monthly_income", this.gf.father_monthly_income.value);
        input.append("father_other", this.gf.father_other.value);
        input.append("address", this.gf.address.value);
        input.append("country_id", this.gf.country_id.value);
        input.append("state_id", this.gf.state_id.value);
        input.append("city_id", this.gf.city_id.value);
        input.append("pincode", this.gf.pincode.value);

        input.append("city_other", city_oth);
        input.append("remark", this.gf.remark.value);
        input.append("marriage_type", this.gf.marriage_type.value);
        input.append("payment_mode", this.gf.payment_mode.value);
        input.append("payment_type", this.gf.payment_type.value);
        this.fileData = input;

      } else {
        this.fileData.append("name", this.gf.name.value);
        this.fileData.append("gotra", this.gf.gotra.value);
        this.fileData.append("dob", this.gf.dob.value);
        this.fileData.append("mobile", this.gf.mobile.value);
        this.fileData.append("height", this.gf.height.value);
        this.fileData.append("weight", this.gf.weight.value);
        this.fileData.append("color", this.gf.color.value);
        this.fileData.append("education", this.gf.education.value);
        this.fileData.append("business", this.gf.business.value);
        this.fileData.append("monthly_income", this.gf.monthly_income.value);
        this.fileData.append("house", this.gf.house.value);
        this.fileData.append("mangalik", this.gf.mangalik.value);
        this.fileData.append("special_status", this.gf.special_status.value);
        this.fileData.append("brother_married", this.gf.brother_married.value);
        this.fileData.append("brother_unmarried", this.gf.brother_unmarried.value);
        this.fileData.append("father", this.gf.father.value);
        this.fileData.append("mother", this.gf.mother.value);
        this.fileData.append("sister_married", this.gf.sister_married.value);
        this.fileData.append("sister_unmarried", this.gf.sister_unmarried.value);
        this.fileData.append("fname", this.gf.fname.value);
        this.fileData.append("father_business", this.gf.father_business.value);
        this.fileData.append("father_monthly_income", this.gf.father_monthly_income.value);
        this.fileData.append("father_other", this.gf.father_other.value);
        this.fileData.append("address", this.gf.address.value);
        this.fileData.append("country_id", this.gf.country_id.value);
        this.fileData.append("state_id", this.gf.state_id.value);
        this.fileData.append("city_id", this.gf.city_id.value);
        this.fileData.append("pincode", this.gf.pincode.value);

        this.fileData.append("city_other", city_oth);
        this.fileData.append("remark", this.gf.remark.value);
        this.fileData.append("marriage_type", this.gf.marriage_type.value);
        this.fileData.append("payment_mode", this.gf.payment_mode.value);
        this.fileData.append("payment_type", this.gf.payment_type.value);
      }


      console.log('FF', JSON.stringify(this.fileData));
      this.mainservice.matrimonyForm(this.fileData).subscribe(
        response => {
          this.isReady = false;
          if (response.status == 'error') {
            this.notify.showError(response.message, 'Error !!');
          } else {
            if (this.gf.marriage_type.value == 2 && this.gf.payment_mode.value == 1) {
              this.payWithRazor(response.bookings, response.amount);
            } else {
              this.notify.showSuccess(response.message, 'Success !!');
              this.router.navigate(['/']);
            }

          }
        },
        error => {
          this.isReady = false;
          this.notify.showError(error.error['message'], 'Error !!');
        }
      );
    } else {
      this.isReady = false;
      this.notify.showError('Please select all information', 'Error !!');
    }
  }



  indType() {
    if (this.gf.payment_mode.value == 2) {
      this.isindevidualShow = true;
    } else {
      this.isindevidualShow = false;
    }
  }

  marriageType() {
    if (this.gf.marriage_type.value == 2) {
      this.ismarriaedShow = true;
    } else {
      this.ismarriaedShow = false;
    }
  }


  countryType(e: any) {
    if (e.target.value) {
      if (e.target.value == 'other') {
        this.getinForm.controls['city_other'].setValidators([Validators.required]);
        this.cityotherShow = true;
      } else {
        this.getinForm.controls['city_other'].clearValidators();
        this.isState = true;
        let data = {
          'country_id': e.target.value,
        }
        this.getinForm.controls['state_id'].setValidators([Validators.required]);
        this.mainservice.getState(data).subscribe(
          (res: any) => {
            this.stateArr = res['data'];
            this.isState = false;
          });
        this.stateShow = true;

      }
    } else {
      this.getinForm.controls['state_id'].clearValidators();
      this.isState = false;
      this.stateShow = false;
    }
  }

  stateType(e: any) {
    this.cityShow = false;
    this.isState = true;
    if (e.target.value) {
      let data = {
        'state_id': e.target.value,
      }
      this.getinForm.controls['city_id'].setValidators([Validators.required]);
      this.mainservice.getCity(data).subscribe(
        (res: any) => {
          this.cityArr = res['data'];
          let otherarr = {
            id: 'other',
            name: "Other",
            pincode: null,
            state_id: '',
            updated_at: null
          }
          this.cityArr.push(otherarr);
          this.cityShow = true;
          this.isState = false;
        });

    } else {
      this.getinForm.controls['city_id'].clearValidators();
      this.isState = false;
      this.cityShow = false;
    }
  }


  cityType(e: any) {
    if (e.target.value) {
      if (e.target.value == 'other') {
        this.getinForm.controls['city_other'].setValidators([Validators.required]);
        // this.getinForm.addControl('city_other', new FormControl('', Validators.required));
        this.cityotherShow = true;
      } else {
        this.getinForm.controls['city_other'].clearValidators();
        this.cityotherShow = false;
      }
    } else {
      this.getinForm.controls['city_other'].clearValidators();
      this.cityotherShow = false;
    }
  }

  husbandorwifes(e: any) {
    if (e.target.value == 1) {
      this.getinForm.controls['husbandorwife'].setValidators([Validators.required]);
      // this.getinForm.addControl('husbandorwife', new FormControl('', Validators.required));
      this.husbandorwifesShow = true;
    } else {
      this.getinForm.controls['husbandorwife'].clearValidators();
      // this.getinForm.removeControl('husbandorwife');
      this.husbandorwifesShow = false;
    }
  }

  payWithRazor(order_id: any, amount: any) {
    const options: any = {
      key: 'rzp_live_ktlOkCjA20GTNU',
      amount: amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: '', // company name or product name
      description: '',  // product description 
      order_id: order_id, // order_id created by you in backend
      // prefill: {
      //   email: (this.users) ? this.users.email : '',
      //   contact: (this.users) ? this.users.phone : '',
      // },
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#0c238a'
      },
      // "prefill": {
      //   "name": 'sdf',
      //   "email": 'dsfdsf@ff.vv',
      //   "contact": '987654'
      // },
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;
      console.log('response', response);
      if (response) {
        let pay = {
          'paymentId': response.razorpay_payment_id,
          'orderId': response.razorpay_order_id,
          'signature': response.razorpay_signature,
          'type': 2
        }
        // this.spinner.show();
        this.mainservice.verifyMember(pay).subscribe((res: any) => {
          // this.spinner.hide();
          // if (res['data'] != '') {
          this.notify.showSuccess(res.message, 'Success !!');
          this.router.navigate(['/']);
          // }
        }, (error) => {
          // this.spinner.hide();
          this.notify.showError(error.error['message'], 'Error !!');
        });
        // location.reload();
        // this.router.navigate(['/myaccount/my-subscription']);
      }
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }


  submitss() {
    let data = {
      'name': this.gf.name.value,
      'email': this.gf.email.value,
      'mobile': this.gf.mobile.value,
      'message': this.gf.message.value
    }
    // console.log('message', data);
    // this.mainservice.ContactForms(data).subscribe((res: any) => {
    //   if (res['success']) {
    //     this.getinForm.reset();
    //     this.notify.showSuccess(res['message'], "Success !!");
    //   } else {
    //     this.notify.showError(res['message'], "Failure !!");
    //   }
    // });
  }


  ngOnInit(): void {
    this.mainservice.getCountry().subscribe(
      (res: any) => {
        this.countryArr = res['data'];
        let otherarr = {
          id: 'other',
          iso: "Other",
          iso3: "Other",
          name: "OTHER",
          nicename: "India",
          numcode: "356",
          phonecode: "91"
        }
        this.countryArr.push(otherarr);
        console.log("countryArr", this.countryArr)
      });
    // var s = document.createElement("script");
    // s.type = "text/javascript";
    // s.src = "https://checkout.razorpay.com/v1/checkout.js";
    // this.elementRef.nativeElement.appendChild(s);
  }

}
